import { call, put, takeLatest } from 'redux-saga/effects'

import * as actions from '../actionTypes'
import { getProject } from '../api'

function* listingRequestSaga(action) {
  try {
    const { id } = action.payload
    const project = yield call(getProject, id)
    yield put({
      type: actions.LISTING_PROJECT_REQUEST_SUCCESS,
      payload: { project },
    })
  } catch (e) {
    yield put({ type: actions.LISTING_PROJECT_REQUEST_FAILURE, payload: e })
  }
}

const listingSaga = [takeLatest(actions.LISTING_PROJECT_REQUEST, listingRequestSaga)]

export default listingSaga
